module.exports = __webpack_public_path__ + "5e06094481b6dbd73f1506aa95ad8a96.pdf";